/**
 * Disponibilidad del producto en la ficha (CAT-02).
 *
 * El numero es el stock real de la tienda: el mismo que el negocio administra
 * desde su panel y el que descuenta cada venta. La verificacion firme ocurre
 * igual al pagar, porque entre mirar la ficha y pagar puede venderse (CHK-05).
 */

/** Bajo esta cantidad se muestra urgencia en vez del numero a secas. */
const STOCK_CRITICO = 4;

export interface CajaStockProps {
  stock: number;
}

export function CajaStock({ stock }: CajaStockProps) {
  const agotado = stock <= 0;
  const critico = !agotado && stock <= STOCK_CRITICO;
  const clase = agotado ? 'critico' : critico ? 'alerta' : 'ok';

  return (
    <p className={`ficha-stock-caja ficha-stock-caja--${clase}`}>
      <span className="punto punto-vivo" />
      <span>
        <strong>
          {agotado
            ? 'Sin stock en este momento'
            : `${stock} ${stock === 1 ? 'unidad disponible' : 'unidades disponibles'}`}
        </strong>
        <span className="d">
          {agotado
            ? 'Escríbenos por WhatsApp y te avisamos cuando llegue.'
            : 'Stock real. Lo confirmamos de nuevo al momento de pagar.'}
        </span>
      </span>
    </p>
  );
}
